import React from 'react';
import styles from './MapControlButtons.scss';

const MapControlButtons = () => (
  <div className={styles.ctrlButtons}>
    <button className={styles.ctrlZoomIn} type="button">
      <span className={styles.icon} />
    </button>
    <button className={styles.ctrlZoomOut} type="button">
      <span className={styles.icon} />
    </button>
  </div>
);

export default MapControlButtons;
